import { memo } from 'react'

import { GraphicEqOutlined } from '@mui/icons-material'
import { Box, Chip, Stack, Typography } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { NoSrcPlaceholderWrapper } from 'domains/Workspaces/Events/layouts'
import { audioStreamQueryKeys } from 'services/queryKeys'

export type GlobalAudioStatusRowProps = {
  name?: string
  enabled: boolean
  streamId?: string
}

const GlobalAudioStatusRowRaw = ({ name, enabled, streamId }: GlobalAudioStatusRowProps) => {
  const { t } = useTranslation(['common', 'domain'])

  const streamQuery = useQuery({
    ...audioStreamQueryKeys.detail({ streamId: streamId! }),
    enabled: !!streamId,
  })
  const streamName = streamQuery.data?.name || streamId

  return (
    <Stack direction="row" spacing={1.5} alignItems="center" sx={{ py: 1 }}>
      <Box sx={{ flexShrink: 0 }}>
        <NoSrcPlaceholderWrapper>
          <GraphicEqOutlined />
        </NoSrcPlaceholderWrapper>
      </Box>
      <Stack sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="heading-sm" noWrap>
          {name || t('noNameProvided')}
        </Typography>
        <Typography variant="text-sm" color="text.secondary" noWrap>
          {streamName || '—'}
        </Typography>
      </Stack>
      <Chip
        size="small"
        variant="outlined"
        color={enabled ? 'success' : 'default'}
        label={
          enabled ? t('domain:Workspace.Event.ConfigEditor.enabled') : t('domain:Workspace.Event.ConfigEditor.disabled')
        }
      />
    </Stack>
  )
}

export const GlobalAudioStatusRow = memo(GlobalAudioStatusRowRaw)
